<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName"
    descriptionDeleted="Se eliminarán también los spots y autos del usuario. Está seguro que quiere continuar?"
    labelModalConfirm="Si" labelModalCancel="No" removeText="Eliminar Usuario" parentStoreName="Users_scroll"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '/admin/users_scroll'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver tag="div" ref="validator" v-slot="{ }">
      <v-row justify="center" no-gutters>
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="profile_picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil" prepend-icon="fas fa-camera" label="" :defaultImage="profile_picture"
                  :multiple="false" :onSelectedPicture="onSelectedPicture"></Upload>

              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field :error-messages="errors" v-model="data.name" label="Nombre" solo class="input-base"
                  hide-details="auto"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="last_name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Apellidos</div>
                <v-text-field :error-messages="errors" v-model="data.last_name" label="Apellido" solo
                  hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="iva_condition" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Condición ante el IVA</div>
                <v-select :error-messages="errors" v-model="data.iva_condition" :items="iva_conditions"
                  label="Seleccione una opción" solo class="input-base" hide-details="auto"
                  append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="email" rules="required|email" v-slot="{ errors }">
                <div class="label-base pb-1">Email</div>
                <v-text-field :error-messages="errors" v-model="data.email" label="Email" solo hide-details="auto"
                  maxlength="50" :rules="[v => v.length <= 49 || 'Email máximo de 50 caracteres']"
                  class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col class="py-0 px-2">
              <ValidationProvider ref="password" :rules="{ required: !data.id, min: 4 }" v-slot="{ errors }">
                <div class="label-base pb-1">Contraseña</div>
                <!-- <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Contraseña"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : '$eyesClosed'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  solo
                  hide-details="auto"
                  class="input-base"
                ></v-text-field> -->
                <PasswordInput v-model="data.password" :errors="errors" @blur="validate()" :binding="{
                  //class: 'icon-append-16',
                  class: 'input-base',
                  outlined: false,
                  dense: true
                }" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="phone_number" rules="" v-slot="{ errors }">
                <Phone v-model="data.phone_number"></Phone>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="commission_percentage" rules="percentage_valid" v-slot="{ errors }">
                <div class="label-base pb-1">Comisión</div>
                <v-text-field v-model="data.commission_percentage" label="Porcentaje" type="number" inputmode="decimal"
                  solo hide-details="auto" class="input-base no-spinner" @keydown="blockE" min="0"
                  :error-messages="errors[0]" :error="errors.length > 0">
                  <template #prepend-inner>
                    <span class="fonts-s14 fonts-400 fonts-family-DMSans fonts-color-gray3">% </span>
                  </template>

                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="increaseValue">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="decreaseValue">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="cuil" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Cuil</div>
                <v-text-field :error-messages="errors" v-model="data.cuil" label="Ingrese su cuil" solo
                  hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="code_validation_email" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Código de verificación de email</div>
                <v-text-field :error-messages="errors" v-model="data.code_validation_email" disabled
                  label="Ingrese su código de verificación" solo hide-details="auto" class="input-base"
                  readonly></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="registered_province" v-slot="{ errors }">
                <div class="label-base pb-1">Provincia</div>
                <v-text-field :error-messages="errors" v-model="data.registered_province" solo hide-details="auto"
                  class="input-base" label="Provincia"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="registered_city" v-slot="{ errors }">
                <div class="label-base pb-1">Ciudad</div>
                <v-text-field :error-messages="errors" v-model="data.registered_city" solo hide-details="auto"
                  class="input-base" label="Ciudad"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters v-if="
            user_document.user_document_front ||
            user_document.user_document_back
          ">
            <v-col cols="12">
              <h3 class="mb-0">Documentos</h3>
            </v-col>
            <v-col v-if="user_document.user_document_front">
              <v-btn text class="mr-5" :href="user_document.user_document_front" target="_blank">
                <v-icon left>fas fa-file</v-icon>
                Frontal
              </v-btn>
            </v-col>
            <v-col v-if="user_document.user_document_back">
              <v-btn text class="mr-5" :href="user_document.user_document_back" target="_blank">
                <v-icon left>far fa-file</v-icon>
                Reverso
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/UploadProfile";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Phone from "@/components/Form/Phone";
import PasswordInput from "@/components/Form/PasswordInput";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver, Phone, PasswordInput },

  data() {
    return {
      storeName: "Users_scroll",
      title: this.$route.params.id ? "Editar usuario" : "Crear usuario",
      filteredAttributes: ["profile_picture"],
      show1: false,
      profile_picture: "",
      user_document: {
        user_document_back: null,
        user_document_front: null,
      },
      data: {
        name: "",
        last_name: "",
        iva_condition: "",
        email: "",
        password: "",
        phone_number: "",
        cuil: "",
        profile_picture: undefined,
        commission_percentage: null,
        code_validation_email: "",
        registered_province: "",
        registered_city: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Users.status,
      iva_conditions: (state) => state.Users.iva_conditions,
    }),
  },
  watch: {},
  methods: {
    blockE(e) {
      const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
      const currentValue = e.target.value;
      if (allowedKeys.includes(e.key)) return;

      if (e.key === "." && !currentValue.includes(".")) return;
      if ((e.key < "0" || e.key > "9") && e.key !== ".") {
        e.preventDefault();
      }
    },
    increaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      this.data.commission_percentage = (val + 1).toString();
    },

    decreaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      if (val > 0) this.data.commission_percentage = (val - 1).toString();
    },
    onCreate(data) {
      if (data.user_document) {
        this.user_document = {
          ...this.user_document,
          ...data.user_document,
        };
      }
    },
    onSelectedPicture(file) {
      console.log('🐱 file: ---- 🐱 \n', file);
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.profile_picture = fr.result;
      };
      fr.onerror = function () {
        self.profile_picture = "";
      };
      fr.readAsDataURL(this.data.profile_picture);
    },
  },
};
</script>
